// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1d7f8f70","703":"e50f8559"}[chunkId] + ".chunk.js";
};